import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

export const root = (theme: Theme) => css`
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-block;
  fill: currentColor;
  flex-shrink: 0;
  font-size: ${theme.fontSize.lg};
`;
